import { gql } from 'graphql-tag';

/**
 * GraphQL query to get a single dog by ID
 */
export const GET_DOG = gql`
  query GetDog($id: ID!) {
    getDog(id: $id) {
      id
      name
      longName
      ownedBy
      dateOfBirth
      dam
      sire
      color
      sex
      hips
      elbows
      pra
      eic
      hpnk
      category
      content
      coverImgUrl
      hipAndElbowUrl
      dnaUrl
      pedigreeUrl
      cardiacUrl
      eyeClearanceUrl
      images
      imagesUrls
    }
  }
`;

/**
 * GraphQL query to get multiple dogs with optional filtering
 */
export const GET_DOGS = gql`
  query GetDogs($filter: DogFilter) {
    getDogs(filter: $filter) {
      id
      name
      longName
      ownedBy
      dateOfBirth
      dam
      sire
      color
      sex
      hips
      elbows
      pra
      eic
      hpnk
      category
      content
      coverImgUrl
      hipAndElbowUrl
      dnaUrl
      pedigreeUrl
      cardiacUrl
      eyeClearanceUrl
      images
      imagesUrls
    }
  }
`;

/**
 * GraphQL mutation to create a new dog
 */
export const ADD_DOG = gql`
  mutation AddDog($input: DogInput!) {
    addDog(input: $input) {
      id
      name
      longName
      ownedBy
      dateOfBirth
      dam
      sire
      color
      sex
      hips
      elbows
      pra
      eic
      hpnk
      category
      content
      coverImgUrl
      hipAndElbowUrl
      dnaUrl
      pedigreeUrl
      cardiacUrl
      eyeClearanceUrl
      images
      imagesUrls
    }
  }
`;

/**
 * GraphQL mutation to update an existing dog
 */
export const EDIT_DOG = gql`
  mutation EditDog($id: ID!, $input: DogInput!) {
    editDog(id: $id, input: $input) {
      id
      name
      longName
      ownedBy
      dateOfBirth
      dam
      sire
      color
      sex
      hips
      elbows
      pra
      eic
      hpnk
      category
      content
      coverImgUrl
      hipAndElbowUrl
      dnaUrl
      pedigreeUrl
      cardiacUrl
      eyeClearanceUrl
      images
      imagesUrls
    }
  }
`;

/**
 * GraphQL mutation to delete a dog
 */
export const DELETE_DOG = gql`
  mutation DeleteDog($id: ID!) {
    deleteDog(id: $id)
  }
`;
